module.exports = __webpack_public_path__ + "static/media/empty-requests.f0e0d6f0.svg";